import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";
import { useEffect } from "react";
import type { BlockPlotModelT } from "../../../../../../schema/block/plot";
import { DAY_MS } from "@ui/i18n/formatDate";

export const useCycleDisplayState = createGlobalState({
  key: "dashboardCycleDisplay",
  storage: "local",
  scoped: true,
  type: io.boolean,
});

export const useCycleDisplay = ({
  block,
  chart,
  scope,
}: {
  block: BlockPlotModelT;
  chart: React.RefObject<Highcharts.Chart>;
  scope: string;
}) => {
  const [displayCycle, setDisplayCycle] = useCycleDisplayState({
    scope,
    defaultValue: Boolean(block.config.options?.displayCycle),
  });

  useEffect(() => {
    if (!chart.current) return;
    for (const axis of chart.current.xAxis) {
      axis.update(
        {
          breaks: axis.options.breaks?.map((b: Highcharts.XAxisBreaksOptions) => ({
            ...b,
            breakSize: displayCycle
              ? (b?.to || 0) - (b?.from || 0)
              : Math.min(DAY_MS, ((b?.to ?? 0) - (b?.from ?? 0)) / 10),
          })),
        },
        false,
      );
    }
    chart.current.redraw(false);
  }, [chart, displayCycle]);

  return [displayCycle, setDisplayCycle] as const;
};
